import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const WAITING_REASONS = [
  { value: '', labelKey: 'No specific reason' },
  { value: 'parts', labelKey: 'waiting_reason.parts' },
  { value: 'customer_approval', labelKey: 'waiting_reason.customer_approval' },
  { value: 'insurance', labelKey: 'waiting_reason.insurance' },
  { value: 'subcontractor', labelKey: 'waiting_reason.subcontractor' },
  { value: 'capacity', labelKey: 'waiting_reason.capacity' },
  { value: 'lunch', labelKey: 'waiting_reason.lunch' },
];

function WaitingReasonDialog({ open, handleClose, onConfirm }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason);
    setReason('');
  };

  const handleCancel = () => {
    setReason('');
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '16px' } }}
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 4, pb: 1 }}>
        <Box sx={{ mb: 2 }}>
          <HourglassEmptyIcon sx={{ fontSize: 48, color: 'warning.main' }} />
        </Box>
        {t('Set as waiting')}
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
          {t('Select waiting reason')}
        </Typography>
        <RadioGroup value={reason} onChange={(e) => setReason(e.target.value)}>
          {WAITING_REASONS.map((r) => (
            <FormControlLabel
              key={r.value}
              value={r.value}
              control={<Radio size="small" />}
              label={t(r.labelKey)}
              sx={{ ml: 0.5 }}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1, gap: 1, justifyContent: 'center' }}>
        <Button
          onClick={handleCancel}
          variant="outlined"
          sx={{
            borderRadius: '10px',
            px: 3,
            py: 1,
            borderColor: 'divider',
            color: 'text.secondary',
            '&:hover': { borderColor: 'text.primary', bgcolor: 'transparent' },
          }}
        >
          {t('Cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          sx={{ borderRadius: '10px', px: 3, py: 1 }}
        >
          {t('Yes, set waiting')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WaitingReasonDialog;
